import { render, staticRenderFns } from "./HomeSilder.vue?vue&type=template&id=58034944&scoped=true&"
import script from "./HomeSilder.vue?vue&type=script&lang=js&"
export * from "./HomeSilder.vue?vue&type=script&lang=js&"
import style0 from "./HomeSilder.vue?vue&type=style&index=0&id=58034944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58034944",
  null
  
)

export default component.exports